const REMEMBER_KEY = 'stavyn_remember_login';
const SAVED_EMAIL_KEY = 'stavyn_saved_email';

export function getRememberLoginPreference() {
  try {
    return localStorage.getItem(REMEMBER_KEY) === '1';
  } catch {
    return false;
  }
}

export function setRememberLoginPreference(enabled) {
  try {
    if (enabled) localStorage.setItem(REMEMBER_KEY, '1');
    else localStorage.removeItem(REMEMBER_KEY);
  } catch {
    // ignore
  }
}

export function getSavedLoginEmail() {
  try {
    const v = localStorage.getItem(SAVED_EMAIL_KEY);
    return v && typeof v === 'string' ? v : '';
  } catch {
    return '';
  }
}

export function setSavedLoginEmail(email) {
  try {
    const clean = String(email || '').trim().toLowerCase();
    if (clean) localStorage.setItem(SAVED_EMAIL_KEY, clean);
    else localStorage.removeItem(SAVED_EMAIL_KEY);
  } catch {
    // ignore
  }
}

export function clearSavedLoginEmail() {
  try {
    localStorage.removeItem(SAVED_EMAIL_KEY);
  } catch {
    // ignore
  }
}
